<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex'
import filter from 'js/filter'
import { Alogin } from '@/service/app'
import { editXuserChannel } from '@/service/vbef'
export default {
  components: {},
  created() {
    const origin = this.$store.state.vbef_path
    const mode = this.$route.params.mode

    if (mode === 'apple' || mode === 'google') {
      const { state, userKey } = this.$route.query
      if (userKey) {
        this.$store.commit('updateUserKey', userKey)
        const localsharechannel = localStorage.getItem('sharechannel') || 0
        if (localsharechannel) {
          this.editXuserChannel(localsharechannel)
        }
        window.location.href = `${origin}${state ? state : ''}`
      } else {
        window.location.href = origin
      }
    } else if (mode === 'linkedin') {
      this.getLinkedInCode()
    } else {
      window.location.href = `${origin}/404`
    }
  },
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
  },
  computed: {},
  methods: {
    async getLinkedInCode() {
      const { state, code, error } = this.$route.query
      const origin = this.$store.state.vbef_path
      if (error) {
        console.error('领英授权失败：', error)
        this.$message.error('登录失败，请重试')
        return
      }
      if (code) {
        const params = {
          code,
          type: 8,
          loginPlatform: this.isMobile ? 9 : 8,
          redirectUrl: `${origin}/callback/linkedin`,
        }
        const res = await Alogin(params)
        if (res.code == 0) {
          this.$store.commit('updateUserKey', res.data.userKey)
          const localsharechannel = localStorage.getItem('sharechannel') || 0
          if (localsharechannel) {
            this.editXuserChannel(localsharechannel)
          }
          window.location.href = `${origin}${state}`
        } else {
          if (this.isMobile) this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          else this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
        }
      }
    },
    async editXuserChannel(localsharechannel) {
      let res = await editXuserChannel({
        actId: this.$store.state.activityId,
        channelId: localsharechannel,
      })
    },
  },
}
</script>
<style lang='stylus' scoped></style>